module.exports = __webpack_public_path__ + "img/temp-bg-moving.ce86a0b5.png";